var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTtDev = function SvgTtDev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: "inherit",
      height: "inherit"
    },
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M25.25 14.75 30.5 20l-5.25 5.25m-10.5 0L9.5 20l5.25-5.25m7.5-3-4.5 16.5"
  })));
};
export { SvgTtDev as ReactComponent };
export default __webpack_public_path__ + "785b88798516f16b15ce6045b1b1ffab.svg";